function setError(root, message) {
  const el = root.querySelector('[data-ca-login-error]');
  if (!el) return;
  if (!message) {
    el.hidden = true;
    el.textContent = '';
    return;
  }
  el.hidden = false;
  el.textContent = message;
}

window.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-ca-login]');
  if (!root) return;

  const buttons = root.querySelectorAll('[data-ca-login-button]');
  if (!buttons.length) return;

  function handleLogin(btn) {
    setError(root, null);
    btn.disabled = true;
    window.CustomerAccount.startCustomerAccountLogin({
      storefrontDomain: root.dataset.storefrontDomain,
      clientId: root.dataset.clientId,
      redirectUri: root.dataset.redirectUri,
      locale: root.dataset.locale,
      regionCountry: root.dataset.regionCountry,
    }).catch(function (e) {
      setError(root, e && e.message ? e.message : 'Login failed.');
      btn.disabled = false;
    });
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () { handleLogin(button); });
  });
});

